(() => {

  var MarqueeApp = (() => {
    var scroll = (container) => {
      if (!container) return;
      const marquee = container.querySelector('.marquee');
      const fixedMarquee = container.querySelector('.fixed-marquee');
      if (!marquee) return;
      if (fixedMarquee.clientWidth == fixedMarquee.scrollWidth) {
        container.classList.add('not-play');
      } else {
        container.classList.remove('not-play');
        marquee.scrollTo((marquee.scrollLeft + 1) % marquee.scrollWidth, 0);
      }
    }
    var initEachContainer = (container) => {
      if (!container) return;
      setInterval(() => {
        scroll(container);
      }, 30);
      scroll(container);
    }
    var initialize = () => {
      document.querySelectorAll('[js-marquee]').forEach(element => {
        initEachContainer(element);
      });
    }
    return {
      init: initialize
    }
  })();

  var FaqApp = (() => {
    var close = (element) => {
      if (!element) return;
      const answer = element.querySelector('[js-answer]');
      if (!answer) return;
      element.classList.remove('open');
      answer.style.maxHeight = '0px';
    }
    var open = (element) => {
      if (!element) return;
      const container = element.closest('[js-container]');
      if (container) {
        container.querySelectorAll('[js-faq]').forEach(eachElement => {
          close(eachElement);
        });
      }
      const answer = element.querySelector('[js-answer]');
      if (!answer) return;
      element.classList.add('open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
    var initialize = () => {
      document.querySelectorAll('[js-faq] [js-question]').forEach(element => {
        element.addEventListener('click', () => {
          const faq = element.closest('[js-faq]');
          if (faq.classList.contains('open')) {
            close(faq);
          } else {
            open(faq);
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var CountingUpAnimationApp = (() => {
    let containers = [];
    let flags = [];
  
    var check = () => {
      containers.forEach((container, index) => {
        if (flags[index]) return;
  
        if (container.getBoundingClientRect().y > (-1*container.offsetHeight) && container.getBoundingClientRect().y < window.innerHeight) {
          flags[index] = true;
          startAnimation(container);
        }
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-counting-up-animation]').forEach(container => {
        containers.push(container);
        flags.push(false);
      });
      check();
      window.addEventListener('scroll', () => {
        check();
      });
    }
    
    var startAnimation = (container) => {
      const targetNumber = parseInt(container.innerHTML);
      if (isNaN(targetNumber) || targetNumber <= 0) return;
  
      const raisedFeatureContainer = container.closest('.raised-feature');
      if (raisedFeatureContainer) {
        raisedFeatureContainer.style.minWidth = raisedFeatureContainer.offsetWidth + 'px';
      }
      
      let currentNumber = 0;
      let step = 1; // Always use step of 1 for integers
      let delay = 15;
      
      var countup = () => {
        container.innerHTML = currentNumber;
        if (container.closest('[js-container]')) {
          container.closest('[js-container]').style.setProperty('--percent', currentNumber + '%');
        }
        if (currentNumber < targetNumber) {
          currentNumber += step;
          
          // Slow down near the end
          if (currentNumber >= (targetNumber - step*16)) {
            delay = 20;
          }
          if (currentNumber >= (targetNumber - step*12)) {
            delay = 25;
          }
          if (currentNumber >= (targetNumber - step*8)) {
            delay = 30;
          }
          if (currentNumber >= (targetNumber - step*4)) {
            delay = 35;
          }
          
          if (currentNumber > targetNumber) {
            currentNumber = targetNumber;
          }
          
          setTimeout(countup, delay);
        }
      }
      countup();
    }
    
    return {
      init: initialize
    }
  })();

  var CustomFeaturedProductApp = (() => {
    var isAvailableVariant = (variant_id) => {
      let is_available = false;
      window.featuredProductData.product.variants.forEach(variant => {
        if (String(variant.id) === String(variant_id)) {
          is_available = variant.available;
          console.log('here is variant', variant);
        }
      });
      return is_available;
    }
    var changeVariant = (container, element) => {
      if (!container || !element) return;
      container.querySelectorAll('[js-variant-picker] [js-option]').forEach(e => {
        e.classList.remove('selected');
      });
      element.classList.add('selected');
      const variantPicker = container.querySelector('[js-variant-picker]');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-selected-variant-id', element.getAttribute('js-option'));
      if (!isAvailableVariant(element.getAttribute('js-option'))) {
        const notification = container.querySelector('[js-stock-notification]');
        if (notification) notification.classList.add('d-none');
        const atcButton = container.querySelector('[js-atc]');
        if (atcButton) atcButton.classList.add('disabled');
      } else {
        const notification = container.querySelector('[js-stock-notification]');
        if (notification) notification.classList.remove('d-none');
        const atcButton = container.querySelector('[js-atc]');
        if (atcButton) atcButton.classList.remove('disabled');
      }
    }
    var addToCart = (container) => {
      if (!container) return;
      
      const variantPicker = container.querySelector('[js-variant-picker]');
      const selectedVariantId = variantPicker ? variantPicker.getAttribute('data-selected-variant-id') : container.getAttribute('data-default-variant-id');
      
      if (!selectedVariantId) {
        console.warn('No variant selected');
        return;
      }
      
      // Check if variant is available
      if (!isAvailableVariant(selectedVariantId)) {
        console.warn('Selected variant is not available');
        return;
      }
      
      // Get quantity (default to 1 if no quantity selector)
      const quantityInput = container.querySelector('[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      // Disable add to cart button during request
      const atcButton = container.querySelector('[js-atc]');
      if (atcButton) {
        atcButton.setAttribute('aria-busy', 'true');
        atcButton.classList.add('disabled', 'loading');
        atcButton.style.pointerEvents = 'none';
        atcButton.style.opacity = '0.6';
        
        // Store original content and show loading spinner
        const originalContent = atcButton.innerHTML;
        atcButton.setAttribute('data-original-content', originalContent);
        
        // Create loading spinner
        const loadingSpinner = `
          <span class="loading-spinner" style="
            display: inline-block;
            width: 16px;
            height: 16px;
            border: 2px solid transparent;
            border-top: 2px solid currentColor;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-right: 8px;
          "></span>
        `;
        
        atcButton.innerHTML = loadingSpinner;
        
        // Add CSS animation if it doesn't exist
        if (!document.querySelector('#loading-spinner-styles')) {
          const style = document.createElement('style');
          style.id = 'loading-spinner-styles';
          style.textContent = `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `;
          document.head.appendChild(style);
        }
      }
      
      // Prepare sections to bundle (following theme.js pattern)
      let sectionsToBundle = ["variant-added", "cart-information-drawer"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      
      // Prepare form data
      const formData = new FormData();
      formData.set('id', selectedVariantId);
      formData.set('quantity', quantity);
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', `${window.Shopify.routes.root}variants/${selectedVariantId}`);
      
      // Add any additional properties if they exist
      const properties = container.querySelectorAll('[name*="properties"]');
      properties.forEach(property => {
        if (property.value) {
          formData.set(property.name, property.value);
        }
      });
      
      // Make the add to cart request
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest' // Required for Shopify inventory checks
        }
      })
      .then(response => response.json())
      .then(async (responseJson) => {
        if (responseJson.status && responseJson.status === 422) {
          // Handle error (item not available, etc.)
          throw new Error(responseJson.description || 'Unable to add item to cart');
        }
        
        // Success - get updated cart
        const cartContent = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json());
        cartContent['sections'] = responseJson['sections'];
        
        const header = document.querySelector('header');
        if (header) {
          header.classList.add('sticky-header');
        }
        // Dispatch events following theme.js pattern
        container.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
            blockCartDrawerOpening: false, // Set to true if you don't want drawer to open
            cart: cartContent
          }
        }));
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartContent
          }
        }));
        
        // Optional: Show success feedback
        console.log('Item added to cart successfully');
        
      })
      .catch(error => {
        // Handle errors
        console.error('Error adding to cart:', error);
        
        // Dispatch error event
        container.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            error: error.message || 'Unable to add item to cart'
          }
        }));
        
        // Optional: Show error message to user
        // You could create an error banner here similar to theme.js BuyButtons
      })
      .finally(() => {
        // Re-enable add to cart button
        if (atcButton) {
          atcButton.removeAttribute('aria-busy');
          atcButton.classList.remove('disabled', 'loading');
          atcButton.style.pointerEvents = '';
          atcButton.style.opacity = '';
          
          // Restore original content
          const originalContent = atcButton.getAttribute('data-original-content');
          if (originalContent) {
            atcButton.innerHTML = originalContent;
            atcButton.removeAttribute('data-original-content');
          }
        }
      });
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-variant-picker] [js-option]').forEach((element, index) => {
        element.addEventListener('click', () => {
          changeVariant(container, element);
        });
        if (index == 1) {
          changeVariant(container, element);
        }
      });
      container.querySelectorAll('[js-atc]').forEach(element => {
        element.addEventListener('click', () => {
          addToCart(container);
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-custom-featured-product]').forEach(element => {
        initEachContainer(element);
      });
    }
    return {
      init: initialize
    }
  })();

  var VideoApp = (() => {
    var toggleVideo = (container) => {
      if (!container || !container.querySelector('video')) return;
      const video = container.querySelector('video');
      if (video.paused) {
        video.play();
        container.classList.add('playing');
      } else {
        video.pause();
        container.classList.remove('playing');
      }
    }
    var initialize = () => {
      document.querySelectorAll('[js-video-wrapper]').forEach(element => {
        element.addEventListener('click', () => {
          toggleVideo(element);
        });
      });
      document.querySelectorAll('[js-video-wrapper] video').forEach(video => {
        video.addEventListener('ended', () => {
          toggleVideo(video.closest('[js-video-wrapper]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var MediaGalleryApp = (() => {
    var initialize = () => {
      document.querySelectorAll('.product-gallery__media-list-wrapper .product-gallery__media').forEach(element => {
        element.addEventListener('click', () => {
          if (window.innerWidth < 1000) {
            const zoomButton = element.closest('.product-gallery__media-list-wrapper').querySelector('button[is="product-zoom-button"]');
            if (zoomButton) {
              zoomButton.click();
            }
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var StickyHeaderApp = (() => {
    var updateTopOffset = () => {
      const announcementBar = document.querySelector('.shopify-section--announcement-bar');
      const header = document.querySelector('header');
      if (!announcementBar || !header) return;
      header.style.setProperty('--announcement-height', `${announcementBar.clientHeight}px`);
    }
    var initialize = () => {
      updateTopOffset();
      window.addEventListener('resize', () => {
        updateTopOffset();
      });
      window.addEventListener('scroll', () => {
        updateTopOffset();
      });
    }
    return {
      init: initialize
    }
  })();

  var BDTestimonialSliderApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-testimonial-slider]').forEach(element => {
        new Flickity(element, {
          prevNextButtons: false,
          adaptiveHeight: false,
          wrapAround: false,
          pageDots: false,
          contain: true,
          imagesLoaded: true,
          cellAlign: 'left'
        });
      });
    }
    return {
      init: initialize
    }
  })();

  
  var PreventCartEventFunc = (() => {
    var initialize = () => {
      document.addEventListener('DOMContentLoaded', function () {
        const productForm = document.querySelector('form[action*="/cart/add"]')

        if (productForm) {
          productForm.addEventListener('submit', async function (e) {
            e.preventDefault() // ← stops the page from redirecting to /cart

            const formData = new FormData(productForm)

            try {
              // Step 1: Add item to cart via AJAX
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
              })

              if (!response.ok) throw new Error('Add to cart failed')

              // Step 2: Open the drawer
              CartDrawer.open();
            } catch (error) {
              console.error('Add to cart error:', error)
              // Fallback: submit the form normally if something goes wrong
              productForm.submit()
            }
          })
        }
      })
    }
    return {
      init: initialize
    }
  })();

  var CartButtonEventFunc = (() => {
    var initialize = () => {
      document.addEventListener('click', async function (e) {
        // Plus button
        if (e.target.closest('.qty-btn--plus')) {
          e.preventDefault()
          e.stopPropagation()
          const item = e.target.closest('.cart-item')
          const key = item?.dataset.key
          const input = item?.querySelector('.qty-input')
          if (key && input) {
            await CartDrawer.updateQty(key, parseInt(input.value) + 1)
          }
        }

        // Minus button
        if (e.target.closest('.qty-btn--minus')) {
          e.preventDefault()
          e.stopPropagation()
          const item = e.target.closest('.cart-item')
          const key = item?.dataset.key
          const input = item?.querySelector('.qty-input')
          if (key && input) {
            const newQty = parseInt(input.value) - 1
            if (newQty >= 0) await CartDrawer.updateQty(key, newQty)
          }
        }

        // Remove button
        if (e.target.closest('.cart-item__remove')) {
          e.preventDefault()
          e.stopPropagation()
          const key = e.target.closest('.cart-item')?.dataset.key
          if (key) await CartDrawer.removeItem(key)
        }

      })
    }
    return {
      init: initialize
    }
  })();

  var AddToCartButtonEventFunc = (() => {
    var initialize = () => {
      let isAddingToCart = false;

// ✅ Single handler function — shared by both intercept methods
      async function handleATC(form) {
        if (isAddingToCart) return;
        isAddingToCart = true;

        const btn = form.querySelector('[name="add"], .product-form__submit, #AddToCart');
        const originalHTML = btn?.innerHTML || '';

        if (btn) {
          btn.disabled  = true;
          btn.innerHTML = '...';
        }

        try {
          const formData = new FormData(form);

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData,
          });

          const data = await res.json();

          if (!res.ok) throw new Error(data.description || 'Add to cart failed');

          await CartDrawer.refreshCart();
          CartDrawer.open();
          CartDrawer.refreshCount();

        } catch (error) {
          console.error('[ATC] Error:', error);
        } finally {
          if (btn) {
            btn.disabled  = false;
            btn.innerHTML = originalHTML;
          }
          isAddingToCart = false;
        }
      }

      function interceptATCForm(form) {
        if (!form || form.dataset.cartIntercepted) return;
        form.dataset.cartIntercepted = 'true';

        // ✅ Method 1 — Override form.submit() directly
        // Catches CustomBundlePage.js calling form.submit() programmatically
        form.submit = function () {
          handleATC(form);
        };

        // ✅ Method 2 — Intercept submit event at capture phase
        // Catches direct form submissions before any other listener
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          handleATC(form);
        }, true);

        // ✅ Method 3 — Intercept ATC button click at capture phase
        // Catches CustomBundlePage.js listening for button clicks
        form.addEventListener('click', function (e) {
          const btn = e.target.closest('[name="add"], .product-form__submit, #AddToCart');
          if (!btn) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          handleATC(form);
        }, true);
      }

      window.addEventListener('load', function () {

        // ✅ Intercept all existing ATC forms
        document.querySelectorAll('form[action*="/cart/add"]').forEach(interceptATCForm);

        // ✅ Watch for dynamically injected forms from CustomBundlePage.js
        const observer = new MutationObserver(function () {
          document.querySelectorAll('form[action*="/cart/add"]:not([data-cart-intercepted])').forEach(interceptATCForm);
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }
    return {
      init: initialize
    }
  })();

  
  let reploAddToCartApp = (() => {
    let initialize = () => {
      window.addEventListener("replo-product-added", (e) => {
        console.log("Here is the replo event listener");
        e.preventDefault();

        CartDrawer.refreshCart();
        CartDrawer.open();
        CartDrawer.refreshCount();
      });
    }
    return {
      init: initialize
    }
  })();

  var BDCartUpsellSliderFunc = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-cart-upsell-slider]').forEach(element => {
        new Flickity(element, {
          prevNextButtons: false,
          adaptiveHeight: false,
          wrapAround: false,
          pageDots: false,
          contain: true,
          imagesLoaded: true,
          cellAlign: 'left',
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var BDHeaderBarSliderApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-header-bar-slider]').forEach(element => {
        new Flickity(element, {
          prevNextButtons: false,
          adaptiveHeight: false,
          wrapAround: false,
          pageDots: false,
          contain: true,
          imagesLoaded: true,
          autoPlay: true,
          wrapAround: true,
          cellAlign: 'left'
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      MarqueeApp.init();
      FaqApp.init();
      CountingUpAnimationApp.init();
      CustomFeaturedProductApp.init();
      VideoApp.init();
      MediaGalleryApp.init();
      StickyHeaderApp.init();
      BDTestimonialSliderApp.init();
      PreventCartEventFunc.init()
      CartButtonEventFunc.init()
      AddToCartButtonEventFunc.init();
      reploAddToCartApp.init();
      BDCartUpsellSliderFunc.init();
      BDHeaderBarSliderApp.init();
    }
    return {
      init: initialize
    }
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();